import React from 'react';
import {FLIP_CARD_SIDE, FlipCardElementTypes, IFlipCardElements} from '../../../../incase-domain/elements/flipCard';
import {ELEMENT} from '../../../../incase-domain/elements/base/ElementTypes';
import {IElementImage} from '../../../../incase-domain/elements/image';
import ElementStaticText from '../text/static.text';
import ElementStaticList from '../static.list';
import ElementHtml from '../text/html';
import {IElementStaticList} from '../../../../incase-domain/elements/staticList';
import {IElementHtml} from '../../../../incase-domain/elements/html';
import {IElementStaticText} from '../../../../incase-domain/elements/staticText';
import ElementImage from '../media/image';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';

interface FlipCardElementProps {
    element: Record<FLIP_CARD_SIDE, IFlipCardElements>;
    flipCardSide: FLIP_CARD_SIDE;
    type: FlipCardElementTypes;
    device?: DeviceType;
}

export default function FlipCardElement(props: FlipCardElementProps): JSX.Element {
    const {element, flipCardSide, type, device = DeviceType.DESKTOP} = props;

    switch (type) {
        case ELEMENT.IMAGE:
            return <ElementImage element={element[flipCardSide] as IElementImage} />;
        case ELEMENT.STATIC_TEXT:
            return <ElementStaticText device={device} element={element[flipCardSide] as IElementStaticText} />;
        case ELEMENT.HTML:
            return <ElementHtml element={element[flipCardSide] as IElementHtml} />;
        case ELEMENT.STATIC_LIST:
            return <ElementStaticList device={device} element={element[flipCardSide] as IElementStaticList} />;
        default:
            return <div />;
    }
}
